<script>
import _ from 'lodash'
export default {
  props: {
    maxWidth: {
      type: String
    },
    width: {
      type: String,
      default: '300px'
    }
  },
  data () {
    return {
      search: ''
    }
  },
  watch: {
    search: 'onSearch'
  },
  methods: {
    onSearch: _.debounce(function () {
      this.$emit('input', this.search || undefined)
    }, 300),

    clearSearch () {
      this.search = ''
      this.$emit('input', undefined)
    }
  }
}
</script>

<template>
  <div class="search-box d-inline-block">
    <div class="position-relative">
      <b-form-input
        v-model="search"
        class="form-control"
        :placeholder="$attrs.placeholder || 'Search...'"
        type="text"
        v-bind="$attrs"
        :style="{ width, maxWidth }"
        autocomplete="new-password"
      ></b-form-input>

      <i
        class="bx bx-x-circle clear-icon pointer"
        v-if="search"
        @click="clearSearch"
      ></i>
      <i class="bx bx-search-alt search-icon"></i>
    </div>
  </div>
</template>

<style lang="scss">
.search-box {
  .form-control {
    border-radius: 5px !important;
    padding-right: 40px;
  }

  .clear-icon {
    font-size: 16px;
    position: absolute;
    right: 13px;
    top: 0;
    line-height: 38px;
  }
}
</style>
